import { TabProperty } from '../enums';

const TabProps = {
  props: {
    [TabProperty.Tab]: {
      default: () => ({}),
      type: Object,
    },
    [TabProperty.ActiveIndex]: {
      default: 0,
      type: Number,
    },
    [TabProperty.Index]: {
      default: 0,
      type: Number,
    },
  },
};

export default TabProps;
